import { BaseModel } from "sjs-base-model";

// post model
export default class ActivityTypePutModel extends BaseModel {
  status = "";
  data = {};

  constructor(data1) {
    super();

    this.update(data1);
  }
}
